import { get } from '../../../utils/state';

const getHistory = (state) => {
  const history = get(state, 'router.history', []);
  return history;
};

export { getHistory };

export default { getHistory };
